import { render, staticRenderFns } from "./ChangeValidity.vue?vue&type=template&id=8df87f0a&scoped=true&"
import script from "./ChangeValidity.vue?vue&type=script&lang=js&"
export * from "./ChangeValidity.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df87f0a",
  null
  
)

export default component.exports